export const initialState = {
  loading: true,
  config: null,
  error: null,
};

export default initialState;
